module.exports = __webpack_public_path__ + "img/eye.66da2594.svg";